/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable jsx-a11y/img-redundant-alt */
import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { axiosInstance } from "../Axios/https";
import { ColorRing } from "react-loader-spinner";
import Swal from 'sweetalert2'

const HomeComponent = () => {
  const [micro, setMicro] = useState("");
  const [loader, setLoader] = useState(false);
  const navigate = useNavigate();

  const handlerSubmit = (e) => {
    setLoader(true);
    e.preventDefault();
    const formData = new FormData();
    formData.append("microchip_no", micro);
    axiosInstance
      .post("client/pet/search", formData)
      .then((res) => {
        console.log(res?.data?.data, "res?.data");
        if (res?.data?.data[0]) {
          Swal.fire({
            title: "Stolen",
            text: "This Pets is Stolen",
            icon: "success"
          });
          const data = res?.data?.data[0];
          console.log(data, "data");
          localStorage.setItem("serach", JSON.stringify(data));
          navigate("searchprofile");
          setLoader(false);
        } else {
          Swal.fire({
            title: "Stolen",
            text: "Please subscribe to access",
            icon: "error"
          });
          setLoader(false);
        }
      })
      .catch((err) => {
        Swal.fire({
          title: "Stolen",
          text: err?.response?.data?.message ? err?.response?.data?.message : "This Pets is not Stolen",
          icon: "error"
        });
        setLoader(false);
      });
  };

  return (
    <>
      <div className="container-fluid">
        <div className="row align-items-center">
          <div className="col-lg-4">
            <img src="assets/images/header.png" alt="" className="logo-png" />
          </div>
          <div className="col-lg-6">
            <div className="context">
              <h1>
                2 Million Pets are Stolen Each Year... only 10% are found.
              </h1>
            </div>
          </div>
        </div>
        <div className="row justify-content-end">
          <div className="col-lg-9 content-two">
            <h1>PET AVENGER COMES TO THE RESCUE WHEN YOUR PET GETS STOLEN</h1>
          </div>
        </div>
      </div>

      <div className="container-fluid mt-5">
        <div className="row justify-content-end">
          <div className="col-lg-4 input-desing">
            <p>Check and See if I am Stolen</p>
            <div className="input">
              <form onSubmit={handlerSubmit}>
                <input
                  type="number"
                  placeholder="Enter Microchip Number"
                  onChange={(e) => setMicro(e.target.value)}
                  value={micro}
                />
                <button type="submit" style={{ background: "none" }}>
                  {loader ? (
                    <ColorRing
                      visible={true}
                      height="28"
                      width="28"
                      ariaLabel="color-ring-loading"
                      wrapperStyle={{}}
                      wrapperClass="color-ring-wrapper"
                      colors={["#fff", "#fff", "#fff", "#fff", "#fff"]}
                    />
                  ) : (
                    <i class="fa-solid fa-magnifying-glass"></i>
                  )}
                </button>
              </form>
            </div>
          </div>
        </div>
      </div>

      <div
        className="container-fluid my-5"
        style={{ background: "#386B98", position: "relative" }}
      >
        <div className="row content-img">
          <div className="col-lg-4 ms-md-5 ms-0">
            <img src="/assets/images/dog.webp" alt="" />
          </div>
          <div className="col-lg-5">
            <p className="pt-4">
              Don't let this be the last time you see your pet.
            </p>
            <div className="d-flex flex-column align-items-center mt-5">
              <h2>Register Your Pet Today</h2>
              <button>Register Now</button>
            </div>
          </div>
        </div>
        <div className="container mt-5">
          <div className="row last-content">
            <div className="col-lg-12">
              <p>
                Your pets microchip doesn't let anyone know your pet is stolen.
                Pet Avenger does that and more. Just $1.00 a month and you will
                have Pet Avenger on your side.
              </p>
              <h2 className="mt-4">
                Register your pet and tell your friends. Lets eliminate pet
                theft and register 1 million pets in 2024.{" "}
              </h2>
            </div>
          </div>
          {/* <div className="row justify-content-center mt-4">
          <div className="col-lg-8 para-last">
            <div className="d-flex justify-content-between">
             <p>Trem of Use</p>
             <p>Privacy</p>
             <p>About Us</p>
             <p>Contact Us</p>
             <p>Register</p>
             <p>FAQ</p>
            </div>
          </div>
          </div>
          <div className="row footer">
            <p>Copyright © 2024 Pet Avenger. All rights reserved. All trademarks, service marks, and tradenames (collectively, the "Marks") are trademarks or registered trademarks of Pet Avenger.</p>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default HomeComponent;
